/*
structure:
    name: 'My Show',
    shortName: 'Show', // optional, uses name if not set
    refId: 'myshow', 
    tags: ['university', 'veterans'],
    images: [
      {
        src: '/images/myshow/Image.jpg',
        thumbnail: '/images/myshow/thumbnail.jpg', // optional, uses src if not set
        title: 'Text Shown With Large Image',
        alt: 'Screen reader text',
      },
    ],
    showThumbnail: '/images/myshow/another_thumb.jpg',
    headline: <><em>My Show</em> at some theater</>,
    description: <>Anything else to print</>,
*/

export const contents = [
  {
    name: 'Arachne (2025)',
    refId: 'arachne',
    tags: ['New Plays', 'Solo Shows', 'Touring', 'Chicago'],
    images: [
      {
        src: '/images/arachne/Arachne5.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne5.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne6.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne6.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne13.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne13.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne15.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne15.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne10.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne10.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne23.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne23.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne9.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne9.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
      {
        src: '/images/arachne/Arachne25.jpg',
        thumbnail: '/images/arachne/thumbs/Arachne25.jpg',
        title: 'Britt Anderson in Arachne',
        alt: 'Britt Anderson in Arachne',
      },
    ],
    showThumbnail: '/images/arachne/thumbs/Arachne25-xs.jpg',
    headline: (
      <>
        <em>Arachne</em> at the Edinburgh Fringe Festival
      </>
    ),
    description: (
      <>
        Written and Performed by Britt Anderson. Produced by Whisper Theatre Collective.
        <br />
        Photos by Edge Photograph UK Ewan Grant.
        <br /> Tour stops: Edinburgh Fringe Festival (Scotland), Cannonball Festival (Philadelphia), Borderlight Fringe (Cleveland), Full Circle Festival (Chicago).
      </>
    ),
  },
  {
    name: 'The Cave (2025)',
    refId: 'cave',
    tags: ['New Plays', 'Chicago'],
    images: [
      /* {
        src: '/images/cave/Cave-10.jpg',
        thumbnail: '/images/cave/thumbs/Cave-10.jpg',
        title: 'H. Adoni Esho and Milla Liss in The Cave',
        alt: 'H. Adoni Esho and Milla Liss',
      }, */
      {
        src: '/images/cave/Cave-12.jpg',
        thumbnail: '/images/cave/thumbs/Cave-12.jpg',
        title: 'Milla Liss, H. Adoni Esho, Aaliyah Montana, and Kirsten Fitzgerald in The Cave',
        alt: 'Milla Liss, H. Adoni Esho, Aaliyah Montana, and Kirsten Fitzgerald',
      },
      {
        src: '/images/cave/Cave-02.jpg',
        thumbnail: '/images/cave/thumbs/Cave-02.jpg',
        title: 'Ashley Neal and Kirsten Fitzgerald in The Cave',
        alt: 'Ashley Neal and Kirsten Fitzgerald',
      },
      {
        src: '/images/cave/Cave-15.jpg',
        thumbnail: '/images/cave/thumbs/Cave-15.jpg',
        title: 'Milla Liss and Aaliyah Montana in The Cave',
        alt: 'Milla Liss and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-16.jpg',
        thumbnail: '/images/cave/thumbs/Cave-16.jpg',
        title: 'Milla Liss, H. Adoni Esho, Kirsten Fitzgerald and Aaliyah Montana in The Cave',
        alt: 'Milla Liss, H. Adoni Esho, Kirsten Fitzgerald and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-25.jpg',
        thumbnail: '/images/cave/thumbs/Cave-25.jpg',
        title: 'H. Adoni Esho and Aaliyah Montana in The Cave',
        alt: 'H. Adoni Esho and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-27.jpg',
        thumbnail: '/images/cave/thumbs/Cave-27.jpg',
        title: 'H. Adoni Esho and Aaliyah Montana in The Cave',
        alt: 'H. Adoni Esho and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-37.jpg',
        thumbnail: '/images/cave/thumbs/Cave-37.jpg',
        title: 'Guy Van Swearingen and Aaliyah Montana in The Cave',
        alt: 'Guy Van Swearingen and Aaliyah Montana',
      },
      /* {
        src: '/images/cave/Cave-38.jpg',
        thumbnail: '/images/cave/thumbs/Cave-38.jpg',
        title: 'Guy Van Swearingen and Aaliyah Montana in The Cave',
        alt: 'Guy Van Swearingen and Aaliyah Montana',
      }, */
      {
        src: '/images/cave/Cave-34.jpg',
        thumbnail: '/images/cave/thumbs/Cave-34.jpg',
        title: 'Kirsten Fitzgerald and Aaliyah Montana in The Cave',
        alt: 'Kirsten Fitzgerald and Aaliyah Montana in The Cave',
      },
      {
        src: '/images/cave/Cave-46.jpg',
        thumbnail: '/images/cave/thumbs/Cave-46.jpg',
        title: 'Milla Liss in The Cave',
        alt: 'Milla Liss',
      },
      {
        src: '/images/cave/Cave-47.jpg',
        thumbnail: '/images/cave/thumbs/Cave-47.jpg',
        title: 'Milla Liss and Aaliyah Montana in The Cave',
        alt: 'Milla Liss and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-50.jpg',
        thumbnail: '/images/cave/thumbs/Cave-50.jpg',
        title: 'Kirsten Fitzgerald and H. Adoni Esho in The Cave',
        alt: 'Kirsten Fitzgerald and H. Adoni Esho',
      },
      {
        src: '/images/cave/Cave-52.jpg',
        thumbnail: '/images/cave/thumbs/Cave-52.jpg',
        title: 'Natalie West, John Judd, and Aaliyah Montana in The Cave',
        alt: 'Natalie West, John Judd, and Aaliyah Montana',
      },
     /*  {
        src: '/images/cave/Cave-55.jpg',
        thumbnail: '/images/cave/thumbs/Cave-55.jpg',
        title: 'Omer Abbas Salem, H. Adoni Esho and Aaliyah Montana in The Cave',
        alt: 'Omer Abbas Salem, H. Adoni Esho and Aaliyah Montana',
      }, */
      {
        src: '/images/cave/Cave-59.jpg',
        thumbnail: '/images/cave/thumbs/Cave-59.jpg',
        title: 'Projections by Eme Ospina-López in The Cave',
        alt: 'Projections by Eme Ospina-López',
      },
      {
        src: '/images/cave/Cave-65.jpg',
        thumbnail: '/images/cave/thumbs/Cave-65.jpg',
        title: 'H. Adoni Esho, Kirsten Fitzgerald, Milla Liss and Aaliyah Montana in The Cave',
        alt: 'H. Adoni Esho, Kirsten Fitzgerald, Milla Liss and Aaliyah Montana',
      },
      {
        src: '/images/cave/Cave-68.jpg',
        thumbnail: '/images/cave/thumbs/Cave-68.jpg',
        title: 'Milla Liss and Aaliyah Montana in The Cave',
        alt: 'Milla Liss and Aaliyah Montana',
      },
    ],
    showThumbnail: '/images/cave/thumbs/sisters.jpg',
    headline: (
      <>
        <em>The Cave</em> at A Red Orchid Theatre
      </>
    ),
    description: (
      <>
        A world premiere by Sadieh Rifai.
        <br />
        Featuring Aaliyah Montana, Ashley Neal, Guy Van Swearingen, H. Adoni Esho, John Judd, Kirsten Fitzgerald, Milla
        Liss, Natalie West, and Omer Abbas Salem.
        <br />
        Scenic Design by Sotirios Livaditis, Lighting Design by Mike Durst, Sound Design by Joe Court, Projection Design
        by Eme Ospina-López, Costume Design by Kotryna Hilko, Wig Design by Hannah Andruss, Prop Design by Julia
        Alvarez.
        <br />
        Stage Management by JC Widman with Faith Locke and Casey Fort.
        <br />
        Assistant Direction and Intimacy Direction by Victoria Nassif, Dramaturgy by Yasmin Zacaria Mikhaiel, Cultural
        Consulting and Dialect Coaching by Ronnie Malley.
        <br />
        Production Management by Patrick Starner, Technical Direction by Tom Daniel.
        <br />
        Photos by Evan Hanover.
      </>
    ),
  },
   {
    name: 'My Name is Rachel Corrie (2024)',
    refId: 'rachel',
    tags: ['Solo Shows', 'Community Engaged', 'Contemporary', 'Touring', 'Chicago'],
    images: [
      {
        src: '/images/rachel/SAM02398.jpg',
        thumbnail: '/images/rachel/thumbs/SAM02398.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/SAM02436.jpg',
        thumbnail:  '/images/rachel/thumbs/SAM02436.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/SAM02474.jpg',
        thumbnail:'/images/rachel/thumbs/SAM02474.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/Rachel_LSC1.png',
        thumbnail:'/images/rachel/thumbs/Rachel_LSC1.png',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Lake Street Church',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/Rachel_LSC2.png',
        thumbnail:'/images/rachel/thumbs/Rachel_LSC2.png',
        title: 'Audience participation in My Name is Rachel Corrie at Lake Street Church',
        alt: 'Audience in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/Rachel_LSC3.png',
        thumbnail:'/images/rachel/thumbs/Rachel_LSC3.png',
        title: 'Emiley Kiser and audience participant in My Name is Rachel Corrie at Lake Street Church',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/Rachel_LSC4.png',
        thumbnail:'/images/rachel/thumbs/Rachel_LSC4.png',
        title: 'Emiley Kiser and audience participant in My Name is Rachel Corrie at Lake Street Church',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/SAM02809.jpg',
        thumbnail: '/images/rachel/thumbs/SAM02809.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      
      {
        src: '/images/rachel/SAM02887.jpg',
        thumbnail: '/images/rachel/thumbs/SAM02887.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/SAM02912.jpg',
        thumbnail: '/images/rachel/thumbs/SAM02912.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      {
        src: '/images/rachel/SAM02931.jpg',
        thumbnail: '/images/rachel/thumbs/SAM02931.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Solstice on the Park',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
      
     /*  {
        src: '/images/rachel/IMG_8893.jpg',
        thumbnail: '/images/rachel/sky.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Alley Cat',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      }, */
      {
        src: '/images/rachel/IMG_8912.jpg',
        thumbnail: '/images/rachel/pen.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Alley Cat',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      },
     /*  {
        src: '/images/rachel/IMG_8870.jpg',
        thumbnail: '/images/rachel/bluebg.jpg',
        title: 'Emiley Kiser in My Name is Rachel Corrie at Alley Cat',
        alt: 'Emiley Kiser in My Name is Rachel Corrie',
      }, */
  
      {
        src: '/images/rachel/IMG_8923.jpg',
        thumbnail: '/images/rachel/bill.jpg',
        title: 'Bill Ayers as an audience reader in My Name is Rachel Corrie at Alley Cat',
        alt: 'Bill Ayers',
      },
      {
        src: '/images/rachel/IMG_8868.jpg',
        thumbnail: '/images/rachel/nadia.jpg',
        title: 'Audience reader in My Name is Rachel Corrie at Alley Cat',
        alt: 'Audience reader',
      },
     
      {
        src: '/images/rachel/IMG_8892.jpg',
        thumbnail: '/images/rachel/reader1.jpg',
        title: 'Audience reader in My Name is Rachel Corrie at Alley Cat',
        alt: 'Audience reader',
      },
     
    ],
    showThumbnail: '/images/rachel/thumbs/emiley4.jpg',
    headline: (
      <>
        <em>My Name is Rachel Corrie</em> presented by The Metal Shop Performance Lab
      </>
    ),
    description: (
      <>
        Taken from the writings of Rachel Corrie. Edited by Katherine Viner and Alan Rickman.
        <br />
        A community-engaged performance. 
        <br />
        Community tour partners include Alley Cat Studios and Orchids True Blue (Evanston, IL), 
        Lake Street Church (Evanston, IL), Bill Ayers (Chicago, IL), 33rd Ward Working Families (Chicago, IL), Clear Creek Creative and Bereans for Palestine (Berea, KY).
        <br />
        Performed by Emiley Kiser, Design by Daphne Agosin with Scenic Painting by Kandi Jamieson.
        <br />
        Photos by Agnes Voltz and Dakota Sillyman.
      </>
    ),
  },
  {
    name: 'Lysistrata (2024)',
    refId: 'lysistrata',
    tags: ['University', 'Classics', 'Chicago'],
    images: [
      {
        src: '/images/lysistrata/lysistrata-09.jpg',
         thumbnail:'/images/lysistrata/thumbs/lysistrata-09.jpg',
        title: 'Cookie Isenberg and Maeve Bradler in Lysistrata',
        alt: 'Cookie Isenberg and Maeve Gomez Bradler',
      },
      {
        src: '/images/lysistrata/lysistrata-08.jpg',
         thumbnail:'/images/lysistrata/thumbs/lysistrata-08.jpg',
        title: 'Liam Bouza Diaz and ensemble in Lysistrata',
        alt: 'Liam Bouza Diaz',
      },
      {
        src: '/images/lysistrata/lysistrata-05.jpg',
        thumbnail:'/images/lysistrata/thumbs/lysistrata-05.jpg',
        title: 'Evan Ozer and Marlee Feacher in Lysistrata',
        alt: 'Evan Ozer and Marlee Feacher',
      },
      {
        src: '/images/lysistrata/CRlysistrata_3.jpg',
        thumbnail: '/images/lysistrata/thumbs/CRlysistrata_3.jpg',
        title: 'Marlee Feacher and P-Jay Adams in Lysistrata',
        alt: 'Marlee Feacher and P-Jay Adams',
      },
      {
        src: '/images/lysistrata/CRlysistrata_2.jpg',
        thumbnail: '/images/lysistrata/thumbs/CRlysistrata_2.jpg',
        title: 'Marlee Feacher, Liam Bouza Diaz and ensemble in Lysistrata',
        alt: 'Marlee Feacher, Liam Bouza Diaz and ensemble',
      },
      {
        src: '/images/lysistrata/lysistrata-01.jpg',
         thumbnail:'/images/lysistrata/thumbs/lysistrata-01.jpg',
        title: 'Eric Jacobson and Audrey Romero in Lysistrata',
        alt: 'Eric Jacobson and Audrey Romero',
      },
      {
        src: '/images/lysistrata/preshow_ladies.jpg',
        thumbnail:'/images/lysistrata/thumbs/preshow_ladies.jpg',
        title: 'Audrey Romero and P-Jay Adams in Lysistrata Pre-Show',
        alt: 'Audrey Romero and P-Jay Adams (Pre-Show)',
      },
      {
        src: '/images/lysistrata/preshow_fisherwoman.jpg',
        thumbnail:'/images/lysistrata/thumbs/preshow_fisherwoman.jpg',
        title: 'Liam Bouza Diaz and Maeve Gomez Bradler in Lysistrata Pre-Show',
        alt: 'Liam Bouza Diaz and Maeve Gomez Bradler (pre-show)',
      },
      {
        src: '/images/lysistrata/preshow_soldiers.jpg',
        thumbnail:'/images/lysistrata/thumbs/preshow_soldiers.jpg',
        title: 'Evan Ozer, Eric Jacobson, and Javier Muñoz in Lysistrata Pre-Show',
        alt: 'Evan Ozer, Eric Jacobson, and Javier Muñoz (Pre-Show)',
      },
    ],
    showThumbnail: '/images/lysistrata/thumbs/lysistrata-09-xs.jpg',
    headline: (
      <>
        <em>Lysistrata</em> at The Theatre School at DePaul University.
      </>
    ),
    description: (
      <>
        Written by Ellen McLaughlin.
        <br />
        Featuring BFA and MFA Performance students in The Theatre School. <br />Costume Design by Spencer Harrigan, Lighting
        Design by Alex Elko, Sound Design by Dylan Kintner, Scenic Design concept by Sofia Fillon, Assistant Scenic
        Design by Squid Berk. 
        <br />Stage Management by Isabelle Smith and Bruno Díaz Miranda. <br />Assistant Direction & Pre-Show Direction by Chaz Haines and Isha Pati. Theater Photos by Anna Rapaport.
        <br />Staircase photos by Chaz Haines.
      </>
    ),
  },
 
  {
    name: 'Witch (2023)',
    refId: 'witch',
    tags: ['University', 'Contemporary', 'Chicago'],
    images: [
      
      {
        src: '/images/witch/Mark5.jpg',
        thumbnail: '/images/witch/thumbs/Mark5.jpg',
        title: 'Mark Bellamare in Witch',
        alt: 'Mark Bellamare in Witch',
      },
      {
        src: '/images/witch/Noah5.jpg',
        thumbnail: '/images/witch/thumbs/Noah5.jpg',
        title: 'Noah Solomon Whittiker in Witch',
        alt: 'Noah Solomon Whittiker in Witch',
      },
      {
        src: '/images/witch/Eliot5-1.jpg',
        thumbnail: '/images/witch/thumbs/Eliot5-1.jpg',
        title: 'Eliot Hall in Witch',
        alt: 'Eliot Hall in Witch',
      },
      {
        src: '/images/witch/Gavin8.jpg',
        thumbnail: '/images/witch/thumbs/Gavin8.jpg',
        title: 'Maeve Gomez Bradler in Witch',
        alt: 'Maeve Gomez Bradler in Witch',
      },
      
      {
        src: '/images/witch/GavinChloe6-2.jpg',
        thumbnail: '/images/witch/thumbs/GavinChloe6-2.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      },
     
     
      {
        src: '/images/witch/handsoff.jpg',
        thumbnail: '/images/witch/thumbs/handsoff.jpg',
        title: 'Eliot Hall and Bella Kelso in Witch',
        alt: 'Eliot Hall and Bella Kelso in Witch',
      },
      
       
      {
        src: '/images/witch/Mark9.jpg',
        thumbnail: '/images/witch/thumbs/Mark9.jpg',
        title: 'Mark Bellamare in Witch',
        alt: 'Mark Bellamare in Witch',
      },
      {
        src: '/images/witch/Noah9.jpg',
        thumbnail: '/images/witch/thumbs/Noah9.jpg',
        title: 'Noah Solomon Whittiker in Witch',
        alt: 'Noah Solomon Whittiker in Witch',
      },
      {
        src: '/images/witch/NoahMark9.jpg',
        thumbnail: '/images/witch/thumbs/NoahMark9.jpg',
        title: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
        alt: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
      },
      {
        src: '/images/witch/Gavin7.jpg',
        thumbnail: '/images/witch/thumbs/Gavin7.jpg',
        title: 'Maeve Gomez Bradler in Witch',
        alt: 'Maeve Gomez Bradler in Witch',
      },
      
      {
        src: '/images/witch/GavinChloe10-4.jpg',
        thumbnail: '/images/witch/thumbs/GavinChloe10-4.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      },
       
       
       {
        src: '/images/witch/Eliot12.jpg',
        thumbnail: '/images/witch/thumbs/Eliot12.jpg',
        title: 'Eliot Hall in Witch',
        alt: 'Eliot Hall in Witch',
      },
      {
        src: '/images/witch/strangle.jpg',
        thumbnail: '/images/witch/thumbs/strangle.jpg',
        title: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
        alt: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
      },
      
      {
        src: '/images/witch/Mark12cloak.jpg',
        thumbnail: '/images/witch/thumbs/Mark12cloak.jpg',
        title: 'Mark Bellamare in Witch',
        alt: 'Mark Bellamare in Witch',
      },
      {
        src: '/images/witch/Mark3.jpg',
        thumbnail: '/images/witch/thumbs/Mark3.jpg',
        title: 'Mark Bellamare in Witch',
        alt: 'Mark Bellamare in Witch',
      },
      
      {
        src: '/images/witch/Chloe13.jpg',
        thumbnail: '/images/witch/thumbs/Chloe13.jpg',
        title: 'Chloe Rodriques in Witch',
        alt: 'Chloe Rodriques in Witch',
      },
      {
        src: '/images/witch/chloe.jpg',
        thumbnail: '/images/witch/thumbs/chloe.jpg',
        title: 'Chloe Rodriques in Witch',
        alt: 'Chloe Rodriques in Witch',
      },
      
   
     
      
      
      
      /*  {
        src: '/images/witch/Bella7.jpg',
        thumbnail: '/images/witch/thumbs/Bella7.jpg',
        title: 'Bella Kelso and Noah Solomon Whittiker in Witch',
        alt: 'Bella Kelso and Noah Solomon Whittiker in Witch',
      },
 */
         /* {
        src: '/images/witch/Gavin2.jpg',
        thumbnail: '/images/witch/thumbs/Gavin2.jpg',
        title: 'Gavin Bradler in Witch',
        alt: 'Gavin Bradler in Witch',
      }, */
    /*   {
        src: '/images/witch/bar.jpg',
        thumbnail: '/images/witch/witch_thumbs/bar.jpg',
        title: 'Noah Solomon Whittiker and Maeve Gomez Bradler in Witch',
        alt: 'Noah Solomon Whittiker and Maeve Gomez Bradler in Witch',
      }, */
      /* {
        src: '/images/witch/mydad.jpg',
        thumbnail: '/images/witch/witch_thumbs/mydad.jpg',
        title: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
        alt: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
      }, */
      /* {
        src: '/images/witch/potluck.jpg',
        thumbnail: '/images/witch/witch_thumbs/potluck.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      }, */
      
      /* {
        src: '/images/witch/flood.jpg',
        thumbnail: '/images/witch/witch_thumbs/flood.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      }, */
      
      
      
      
      
     /*  {
        src: '/images/witch/bella.jpg',
        thumbnail: '/images/witch/witch_thumbs/bella.jpg',
        title: 'Bella Kelso and Noah Solomon Whittiker in Witch',
        alt: 'Bella Kelso and Noah Solomon Whittiker in Witch',
      }, */
     /*  {
        src: '/images/witch/noah.jpg',
        thumbnail: '/images/witch/witch_thumbs/noah.jpg',
        title: 'Bella Kelso and Noah Solomon Whittiker in Witch',
        alt: 'Bella Kelso and Noah Solomon Whittiker in Witch',
      }, */
      
    /*   {
        src: '/images/witch/floor.jpg',
        thumbnail: '/images/witch/witch_thumbs/floor.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      }, */
      /* {
        src: '/images/witch/nothuman.jpg',
        thumbnail: '/images/witch/witch_thumbs/nothuman.jpg',
        title: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
        alt: 'Maeve Gomez Bradler and Chloe Rodriques in Witch',
      }, */
      /* {
        src: '/images/witch/eliot.jpg',
        thumbnail: '/images/witch/witch_thumbs/eliot.jpg',
        title: 'Eliot Hall in Witch',
        alt: 'Eliot Hall in Witch',
      }, */
      /* {
        src: '/images/witch/heir.jpg',
        thumbnail: '/images/witch/witch_thumbs/heir.jpg',
        title: 'Bella Kelso and Noah Solomon Whittiker in Witch',
        alt: 'Bella Kelso and Noah Solomon Whittiker in Witch',
      }, */
      /* {
        src: '/images/witch/fightyou.jpg',
        thumbnail: '/images/witch/witch_thumbs/fightyou.jpg',
        title: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
        alt: 'Mark Bellamare and Noah Solomon Whittiker in Witch',
      }, */
      
      
      /* {
        src: '/images/witch/Eliot11-4.jpg',
        thumbnail: '/images/witch/thumbs/Eliot11-4.jpg',
        title: 'Eliot Hall in Witch',
        alt: 'Eliot Hall in Witch',
      }, */
      
      /* {
        src: '/images/witch/Gavin aria 3.jpg',
        thumbnail: '/images/witch/witch_thumbs/Gavin aria 3.jpg',
        title: 'Maeve Gomez Bradler in Witch',
        alt: 'Maeve Gomez Bradler in Witch',
      }, */
     
     /*  {
        src: '/images/witch/gavin.jpg',
        thumbnail: '/images/witch/thumbs/gavin.jpg',
        title: 'Gavin Bradler in Witch',
        alt: 'Gavin Bradler in Witch',
      }, */
      
      
    ],
    showThumbnail: '/images/witch/thumbs/Noah9-xs.jpg',

    headline: (
      <>
        <em>Witch</em> at The Theatre School at DePaul University
      </>
    ),
    description: (
      <>
        Written by Jen Silverman.
        <br /> Performed by BFA Performance students in The Theatre School.
        <br />Costume Design by Naomi Arroyo, Scenic Design by Elizabeth Hoffhines, Lighting Design by Sam Eads, Sound Design
        by Mia Howard. <br />Stage Management by Alondra Vela and Shreya Khanna, assistant directed by Emma Burkey and Perse
        Grammer, technical direction by Alex Klose, production management by Amelia Osborne. <br />Photos by Sam Eads.
      </>
    ),
  },
  {
    name: 'The Elephant Speaks Jazz (2022)',
    refId: 'elephant',
    tags: ['University', 'Puppets', 'New Plays'],
    images: [
      {
        src: '/images/elephant/_PRO2187-2.jpg',
        thumbnail: '/images/elephant/thumbs/_PRO2187-2.jpg',
        title:
          'The Elephant Speaks Jazz: At Home [Aren Alexander-Battee, Bri Reilly, Lindsay Meath, Spencer Curtis, Erin Milleville, Lukas Nederloe, and Puppeteers - Jessica Schneider, Mikala Clark, Grace Reynolds]',
        alt: 'At Home [Aren Alexander-Battee, Bri Reilly, Lindsay Meath, Spencer Curtis, Erin Milleville, Lukas Nederloe, and Puppeteers - Jessica Schneider, Mikala Clark, Grace Reynolds]',
      },
      {
        src: '/images/elephant/_APR3679-2.jpg',
        thumbnail: '/images/elephant/thumbs/_APR3679-2.jpg',
        title: 'The Elephant Speaks Jazz: Miss Viola meets Ellie',
        alt: 'Miss Viola meets Ellie',
      },
      {
        src: '/images/elephant/_APR3730.jpg',
        thumbnail: '/images/elephant/thumbs/_APR3730.jpg',
        title:
          'The Elephant Speaks Jazz: Tug of War [Aren Alexander-Battee, Bri Reilly, and Puppeteers - Jessica Schneider, Mikala Clark, Spencer Curtis]',
        alt: 'Tug of War [Aren Alexander-Battee, Bri Reilly, and Puppeteers - Jessica Schneider, Mikala Clark, Spencer Curtis]',
      },
      {
        src: '/images/elephant/_APR4099.jpg',
        thumbnail: '/images/elephant/thumbs/_APR4099.jpg',
        title:
          'The Elephant Speaks Jazz: Disguises! [Aren Alexander-Battee, Bri Reilly, Erin Milleville, Lukas Nederloe, and Puppeteers - Jessica Schneider, Mikala Clark, Spencer Curtis]',
        alt: 'Disguises! [Aren Alexander-Battee, Bri Reilly, Erin Milleville, Lukas Nederloe, and Puppeteers - Jessica Schneider, Mikala Clark, Spencer Curtis]',
      },
      {
        src: '/images/elephant/_APR4003.jpg',
        thumbnail: '/images/elephant/thumbs/_APR4003.jpg',
        title: 'The Elephant Speaks Jazz: Sad Clowns [Erin Milleville & Lukas Nederloe]',
        alt: 'Sad Clowns [Erin Milleville & Lukas Nederloe]',
      },
      {
        src: '/images/elephant/_APR3850.jpg',
        thumbnail: '/images/elephant/thumbs/_APR3850.jpg',
        title:
          'The Elephant Speaks Jazz: Ellie Trumpets [Jon Ailabouni and Puppeteers - Jessica Schneider, Mikala Clark, Grace Reynolds]',
        alt: 'Ellie Trumpets [Jessica Schneider, Mikala Clark, Grace Reynolds, and Jon Ailabouni]',
      },
      {
        src: '/images/elephant/_PRO1922.jpg',
        thumbnail: '/images/elephant/thumbs/_PRO1922.jpg',
        title: 'The Elephant Speaks Jazz: Chase: [Aren Alexander-Battee, Bri Reilly, Kjersten Danzig]',
        alt: 'Chase [Aren Alexander-Battee, Bri Reilly, Kjersten Danzig]',
      },
      {
        src: '/images/elephant/_PRO2319-2.jpg',
        thumbnail: '/images/elephant/thumbs/_PRO2319-2.jpg',
        title:
          'The Elephant Speaks Jazz: Swimming [Aren Alexander-Battee, Bri Reilly, Erin Milleville, Lukas Nederloe]',
        alt: 'Swimming [Aren Alexander-Battee, Bri Reilly, Erin Milleville, Lukas Nederloe]',
      },
    ],
    showThumbnail: '/images/elephant/_APR4003_crop.jpg',

    headline: (
      <>
        <em>The Elephant Speaks Jazz</em> at Viterbo University
      </>
    ),
    description: (
      <>
        Performed by the BFA Theater and Music Theater students of the Conservatory for the Performing Arts.
        <br />
        Presented with a grant from the Jim Henson Foundation in collaboration with WonderStruck Theatre Co. as part of
        the Viterbo University New Works Festival.
        <br />
        Concept, Puppetry Design and Scenic Design by Eric Van Wyk, Original Music by Luke Thering, Lighting Design by
        Justin Thomas, Costume Design by Irina Christel, Sound Design by Brett Huus. <br />Photos by Apropos Photography.
      </>
    ),
  },
  {
    name: 'The Pajama Game (2021)',
    refId: 'pajamagame',
    tags: ['University', 'Musicals', 'Classics'],
    images: [
      {
        src: '/images/pajama/IMG_3298-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3291-Overhouse.jpg',
        title: 'Racing With The Clock: Ensemble - The Pajama Game',
        alt: 'Racing With The Clock',
      },
      {
        src: '/images/pajama/IMG_3594-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3594-Overhouse.jpg',
        title: 'Hey There: Jack Scharrer - The Pajama Game',
        alt: 'Hey There',
      },
      {
        src: '/images/pajama/IMG_3676-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3685-Overhouse.jpg',
        title: 'Small Talk: Jack Scharrer and Natalie Davies - The Pajama Game',
        alt: 'Small Talk',
      },
      {
        src: '/images/pajama/IMG_3728-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3728-Overhouse.jpg',
        title: 'Steam Heat: Payton Harper, Rachael Anderson, Iraya Catalina Cress and ensemble - The Pajama Game',
        alt: 'Steam Heat',
      },
      {
        src: '/images/pajama/IMG_3506-Overhouse_cropped.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3506-Overhouse_cropped.jpg',
        title: "Hernando's Hideaway: Rachael Armstrong and Jack Scharrer - The Pajama Game",
        alt: "Hernando's Hideaway",
      },
      {
        src: '/images/pajama/IMG_3533-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3533-Overhouse.jpg',
        title: "Hernando's Hideaway: Rachael Armstrong and Jack Scharrer - The Pajama Game",
        alt: "Hernando's Hideaway",
      },
      {
        src: '/images/pajama/IMG_3633-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3633-Overhouse.jpg',
        title: "Hernando's Hideaway: Ensemble - The Pajama Game",
        alt: "Hernando's Hideaway",
      },
      {
        src: '/images/pajama/IMG_3389-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3389-Overhouse.jpg',
        title: '7.5 Cents: Evan Schmit, Natalie Davies and Ensemble - The Pajama Game',
        alt: '7.5 Cents',
      },
      {
        src: '/images/pajama/IMG_3466-Overhouse.jpg',
        thumbnail: '/images/pajama/thumbs/IMG_3466-Overhouse.jpg',
        title: 'Ensemble in The Pajama Game Finale',
        alt: 'Ensemble',
      },
    ],
    showThumbnail: '/images/pajama/thumbs/IMG_3633-Overhouse-xs.jpg',
    headline: (
      <>
        <em>The Pajama Game</em> at Viterbo University
      </>
    ),
    description: (
      <>
        Performed by the BFA Theater and Music Theater students of the Conservatory for the Performing Arts.
        <br />
        Scenic design by Yuri Okahana-Benson, lighting design by Patrick Strain, costume design by Jen Brown, audio
        engineering by Douglas Wilken.
        <br />
        Photos by Dylan Overhouse Productions.
      </>
    ),
  },
  {
    name: 'The Vulnerable Year (2021)',
    refId: 'vulnerableyear',
    tags: ['Devised', 'Community Engaged', 'Virtual'],
    images: [
      {
        src: '/images/tvy/candle.jpg',
        thumbnail: '/images/tvy/thumbs/candle.jpg',
        title: 'The Vulnerable Year development workshop',
        alt: '#5 Candle',
      },
      {
        src: '/images/tvy/2screen.jpg',
        thumbnail: '/images/tvy/thumbs/2screen.jpg',
        title: 'Grace Dolezal-Ng in The Vulnerable Year development workshop',
        alt: 'Grace Dolezal-Ng',
      },
      {
        src: '/images/tvy/participation.jpg',
        thumbnail: '/images/tvy/thumbs/participation.jpg',
        title: 'Audience participation in The Vulnerable Year development workshop',
        alt: 'Audience participation',
      },
      {
        src: '/images/tvy/postits.jpg',
        thumbnail: '/images/tvy/thumbs/postits.jpg',
        title: 'Grace Dolezal-Ng in The Vulnerable Year development workshop',
        alt: 'Grace Dolezal-Ng',
      },
      {
        src: '/images/tvy/sprinkler.jpg',
        thumbnail: '/images/tvy/thumbs/sprinkler.jpg',
        title: 'Grace Dolezal-Ng in The Vulnerable Year development workshop',
        alt: 'Grace Dolezal-Ng',
      },
    ],
    showThumbnail: '/images/tvy/thumbs/sprinkler-xs.jpg',
    headline: (
      <>
        <em>The Vulnerable Year</em> with The Metal Shop Performance Lab
      </>
    ),
    description: (
      <>
        In-process invited Zoom workshop
        <br />
        A participatory, virtual performance event that sought to create community through the power of vulnerability.
        <br />
        Co-created by Grace Dolezal-Ng (performer), Alex Mallory (director) and Maria Simpkins (writer).
        <br />
        <a href="https://youtu.be/2s7Tj8L3Vqo" target="_blank" rel="noreferrer">
          Click here
        </a>{' '}
        to watch the prologue.
      </>
    ),
  },
  {
    name: 'Ritual of Becoming (2021)',
    refId: 'ritual',
    tags: ['Devised', 'Military Veterans', 'Virtual'],
    images: [
      {
        src: '/images/RoB/RoBstarseeds.jpg',
        thumbnail: '/images/RoB/thumbs/RoBstarseeds.jpg',
        title: 'Maria Salazar in Ritual of Becoming',
        alt: 'Maria Salazar',
      },
      {
        src: '/images/RoB/RoBcut.jpg',
        thumbnail: '/images/RoB/thumbs/RoBcut.jpg',
        title: 'Maria Salazar and Jenny Pacanowski in Ritual of Becoming',
        alt: 'Maria Salazar and Jenny Pacanowski',
      },
      {
        src: '/images/RoB/RoBboysclub.jpg',
        thumbnail: '/images/RoB/thumbs/RoBboysclub.jpg',
        title: 'Jenny Pacanowski in Ritual of Becoming',
        alt: 'Jenny Pacanowski',
      },
      {
        src: '/images/RoB/RoBcastrate.jpg',
        thumbnail: '/images/RoB/thumbs/RoBcastrate.jpg',
        title: 'Jenny Pacanowski in Ritual of Becoming',
        alt: 'Jenny Pacanowski',
      },
      {
        src: '/images/RoB/RoBclay.jpg',
        thumbnail: '/images/RoB/thumbs/RoBclay.jpg',
        title: 'Maria Salazar and Jenny Pacanowski in Ritual of Becoming',
        alt: 'Maria Salazar and Jenny Pacanowski',
      },
      {
        src: '/images/RoB/RoBscars.jpg',
        thumbnail: '/images/RoB/thumbs/RoBscars.jpg',
        title: 'Jenny Pacanowski in Ritual of Becoming',
        alt: 'Jenny Pacanowski',
      },
    ],
    showThumbnail: '/images/RoB/thumbs/RoBcastrate-xs.jpg',
    headline: (
      <>
        <em>Ritual of Becoming</em> with Poetic Theater Productions
      </>
    ),
    description: (
      <>
        A journey of radical self-acceptance and transformation through poetry and clay created by Alex Mallory, Jenny
        Pacanowski and Maria L. Salazar.
        <br />
        Commissioned for Rites of Passage, part of the 2021 Poetic License Festival.
        <br />
        Aired as part of the 2021 Austin Veteran Arts Festival through RokuTV.
        <br />
        Lighting Design by Christina Tang, Projection Design by Lisa Renkel and Brian Pacelli, Sound Design by Ray
        Archie.
        <br />
        Watch video{' '}
        <a href="https://youtu.be/oqR8lunkvBw" target="_blank" rel="noreferrer">
          here
        </a>
      </>
    ),
  },
  {
    name: 'Mary Stuart (2019)',
    refId: 'mary-stuart',
    tags: ['University', 'Classics', 'Chicago'],
    images: [
      {
        src: '/images/mary/MaryStuart-21-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-21-X3.jpg',
        title: 'Elizabeth Dickson and Mia Lennon in Mary Stuart',
        alt: 'Elizabeth Dickson and Mia Lennon',
      },
      {
        src: '/images/mary/MaryStuart-25-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-25-X3.jpg',
        title: 'Hannah Hakim and Elizabeth Dickson in Mary Stuart',
        alt: 'Hannah Hakim and Elizabeth Dickson',
      },
      {
        src: '/images/mary/3L9A1913-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A1913-X2.jpg',
        title: 'Hannah Hakim and Liv Reis in Mary Stuart',
        alt: 'Hannah Hakim and Liv Reis',
      },
      {
        src: '/images/mary/3L9A2054-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2054-X2.jpg',
        title: 'Shane Eichstaedt, Valen-Marie Santos, and Juliet Wolfe in Mary Stuart',
        alt: 'Shane Eichstaedt, Valen-Marie Santos and Juliet Wolfe',
      },
      {
        src: '/images/mary/MaryStuart-93-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-93-X3.jpg',
        title: 'Chisom Diana Dimiri in Mary Stuart',
        alt: 'Chisom Diana Dimiri',
      },
      {
        src: '/images/mary/MaryStuart-119-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-119-X3.jpg',
        title: 'Liv Reis and Natalie Welber in Mary Stuart',
        alt: 'Liv Reis and Natalie Welber',
      },
      {
        src: '/images/mary/MaryStuart-122-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-122-X3.jpg',
        title: 'Natalie Welber and Juliet Wolfe in Mary Stuart',
        alt: 'Natalie Welber and Juliet Wolfe',
      },
      {
        src: '/images/mary/MaryStuart-137-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-137-X3.jpg',
        title: 'Hannah Hakim in Mary Stuart',
        alt: 'Hannah Hakim',
      },
      {
        src: '/images/mary/3L9A2490-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2490-X2.jpg',
        title: 'Mia Lennon and Hannah Hakim in Mary Stuart',
        alt: 'Mia Lennon and Hannah Hakim',
      },
      {
        src: '/images/mary/3L9A2530-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2530-X2.jpg',
        title: 'Hannah Hakim and Chisom Diana Dimiri in Mary Stuart',
        alt: 'Hannah Hakim and Chisom Diana Dimiri',
      },
      {
        src: '/images/mary/MaryStuart-149-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-149-X3.jpg',
        title: 'Hannah Hakim in Mary Stuart',
        alt: 'Hannah Hakim',
      },
      {
        src: '/images/mary/3L9A2629-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2629-X2.jpg',
        title: 'Juliet Wolfe and Hannah Hakim in Mary Stuart',
        alt: 'Juliet Wolfe and Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-171-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-171-X3.jpg',
        title: 'Juliet Wolfe and Hannah Hakim in Mary Stuart',
        alt: 'Juliet Wolfe and Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-177-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-177-X3.jpg',
        title: 'Juliet Wolfe and Hannah Hakim in Mary Stuart',
        alt: 'Juliet Wolfe and Hannah Hakim',
      },
      {
        src: '/images/mary/3L9A2754-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2754-X2.jpg',
        title: 'Hannah Hakim and Liv Reis in Mary Stuart',
        alt: 'Hannah Hakim and Liv Reis',
      },
      {
        src: '/images/mary/3L9A2762-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2762-X2.jpg',
        title: 'Hannah Hakim and Liv Reis in Mary Stuart',
        alt: 'Hannah Hakim and Liv Reis',
      },
      {
        src: '/images/mary/MaryStuart-220-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-220-X3.jpg',
        title: 'Shane Eichstaedt and Stella Cole in Mary Stuart',
        alt: 'Shane Eichstaedt and Stella Cole',
      },
      {
        src: '/images/mary/3L9A2957-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A2957-X2.jpg',
        title: 'Mia Lennon, Yama Pouye, and Liv Reis in Mary Stuart',
        alt: 'Mia Lennon, Yama Pouye, and Liv Reis',
      },
      {
        src: '/images/mary/MaryStuart-236-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-236-X3.jpg',
        title: 'Stella Cole and Juliet Wolfe in Mary Stuart',
        alt: 'Stella Cole and Juliet Wolfe',
      },
      {
        src: '/images/mary/3L9A3103-X2.jpg',
        thumbnail: '/images/mary/thumbs/3L9A3103-X2.jpg',
        title: 'Juliet Wolfe in Mary Stuart',
        alt: 'Juliet Wolfe',
      },
      {
        src: '/images/mary/MaryStuart-290-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-290-X3.jpg',
        title: 'Hannah Hakim in Mary Stuart',
        alt: 'Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-296-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-296-X3.jpg',
        title: 'Shane Eichstaedt and Hannah Hakim in Mary Stuart',
        alt: 'Shane Eichstaedt and Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-316-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-316-X3.jpg',
        title: 'Hannah Hakim in Mary Stuart',
        alt: 'Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-323-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-323-X3.jpg',
        title: 'Hannah Hakim in Mary Stuart',
        alt: 'Hannah Hakim',
      },
      {
        src: '/images/mary/MaryStuart-328-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-328-X3.jpg',
        title: 'Juliet Wolfe in Mary Stuart',
        alt: 'Juliet Wolfe',
      },
      {
        src: '/images/mary/MaryStuart-335-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-335-X3.jpg',
        title: 'Chisom Diana Dimiri and Juliet Wolfe in Mary Stuart',
        alt: 'Chisom Diana Dimiri and Juliet Wolfe',
      },
      {
        src: '/images/mary/MaryStuart-345-X3.jpg',
        thumbnail: '/images/mary/MaryStuart-345-X3.jpg',
        title: 'Juliet Wolfe in Mary Stuart',
        alt: 'Juliet Wolfe',
      },
    ],
    showThumbnail: '/images/mary/thumbs/3L9A3103-xs.jpg',
    headline: (
      <>
        <em>Schiller's Mary Stuart</em> at Northwestern University
      </>
    ),
    description: (
      <>
        in a version by Peter Oswald
        <br />
        Featuring undergraduate students in Theatre.
        <br />
        Watch a 2-minute video featuring outtakes of exploratory work from the rehearsal process{' '}
        <a href="https://youtu.be/lU3-KuxBPXA" target="_blank" rel="noreferrer">
          here.
        </a>
        <br />
        Lighting Design by Gabrielle Strong, Scenic Design by Scott Penner, Costume Design by Drina Krlic, Sound Design
        by Sarah Espinoza.
        <br />
        Photos by Justin Barbin Photography.
        <br />
      </>
    ),
  },
  {
    name: 'Spring Awakening (2018)',
    refId: 'spring-awakening',
    tags: ['University', 'Classics', 'Chicago'],
    images: [
      {
        src: '/images/spring/boys.jpg',
        thumbnail: '/images/spring/thumbs/boys.jpg',
        title: 'Makasha Copeland, Hale Stewart, Jordan Moore, Jake Wallack and Adam Orme in Spring Awakening',
        alt: 'Makasha Copeland, Hale Stewart, Jordan Moore, Jake Wallack and Adam Orme',
      },
      {
        src: '/images/spring/moritzmelchior.jpg',
        thumbnail: '/images/spring/thumbs/moritzmelchior.jpg',
        title: 'Jordan Moore and Adam Orme in Spring Awakening',
        alt: 'Jordan Moore and Adam Orme',
      },
      {
        src: '/images/spring/wendlamrsB.jpg',
        thumbnail: '/images/spring/thumbs/wendlamrsB.jpg',
        title: 'Katy Murphy and Juliet Wolfe in Spring Awakening',
        alt: 'Katy Murphy and Juliet Wolfe',
      },
      {
        src: '/images/spring/wendla.jpg',
        thumbnail: '/images/spring/thumbs/wendla.jpg',
        title: 'Juliet Wolfe in Spring Awakening',
        alt: 'Juliet Wolfe',
      },
      {
        src: '/images/spring/moritzilse.jpg',
        thumbnail: '/images/spring/thumbs/moritzilse.jpg',
        title: 'Madison Fiedler and Jordan Moore in Spring Awakening',
        alt: 'Madison Fiedler and Jordan Moore',
      },
      {
        src: '/images/spring/moritz.jpg',
        thumbnail: '/images/spring/thumbs/moritz.jpg',
        title: 'Jordan Moore in Spring Awakening',
        alt: 'Jordan Moore',
      },
      {
        src: '/images/spring/teachers.jpg',
        thumbnail: '/images/spring/thumbs/teachers.jpg',
        title: 'Adam Orme and ensemble in Spring Awakening',
        alt: 'Adam Orme and ensemble',
      },
      {
        src: '/images/spring/melchior.jpg',
        thumbnail: '/images/spring/thumbs/melchior.jpg',
        title: 'Adam Orme in Spring Awakening',
        alt: 'Adam Orme',
      },
    ],
    showThumbnail: '/images/spring/thumbs/moritzilse-xs.jpg',
    headline: (
      <>
        <em>Spring Awakening</em> at Northwestern University
      </>
    ),
    description: (
      <>
        An original translation by Alex Mallory from Frank Wedekind's <i>Frühlings Erwachen</i> for the MFA Collaboration Series.
        <br />
        Featuring undergraduate students in Theatre. 
        <br />
        Lighting Design by Matt Sharp, Scenic Design by Woongjin Oh, Costume Design by Stephanie Ross, Sound Design by
        Grover Hollway.
        <br />
        Photos by Justin Barbin Photography.
      </>
    ),
  },
  {
    name: 'The Telling Project (2014-18)',
    refId: 'telling',
    tags: ['Military Veterans', 'Community Engaged', 'Chicago', 'New York'],
    images: [
      {
        src: '/images/telling/stanford_leslie.jpg',
        thumbnail: '/images/telling/thumbs/stanford_leslie.jpg',
        title: 'Leslie Bridges and ensemble of military veterans in Telling: Stanford. Photo by Federica Armstrong',
        alt: 'Leslie Bridges in Telling: Stanford',
      },
      {
        src: '/images/telling/nyc_group.JPG',
        thumbnail: '/images/telling/thumbs/nyc_group.JPG',
        title: 'The cast of NYC military veterans and family members onstage in Telling: NYC',
        alt: 'Telling: NYC group',
      },
      {
        src: '/images/telling/shelter_perlman.jpg',
        thumbnail: '/images/telling/thumbs/shelter_perlman.jpg',
        title: 'Long Island military veterans onstage in Telling: Shelter Island',
        alt: 'Telling: Shelter Island group',
      },
      {
        src: '/images/telling/stanford_bobby.jpg',
        thumbnail: '/images/telling/thumbs/stanford_bobby.jpg',
        title: 'Bobby McLean in Telling: Stanford. Photo by Federica Armstrong',
        alt: 'Bobby McLean in Telling: Stanford',
      },
      {
        src: '/images/telling/nyc_letrice.JPG',
        thumbnail: '/images/telling/thumbs/nyc_letrice.JPG',
        title: 'Letrice Coan onstage in Telling: NYC',
        alt: 'Letrice Coan in Telling: NYC',
      },
      {
        src: '/images/telling/stanford_victoria.jpg',
        thumbnail: '/images/telling/thumbs/stanford_victoria.jpg',
        title:
          'Victoria Sanders and ensemble of military veterans and family members in Telling: Stanford. Photo by Federica Armstrong',
        alt: 'Victoria Sanders in Telling: Stanford',
      },
    ],
    headline: <>The Telling Project</>,
    showThumbnail: '/images/telling/thumbs/stanford_leslie-xs.jpg',
    description: (
      <>
        Local military veterans & family members rehearse & perform their own stories for their communities. <br />Local
        producing partners include: 
        <ul>
          <li>The Naomi Ruth Cohen Institute at the Chicago School of Professional Psychology and Piven Theatre in Chicago and Evanston, IL</li> 
        <li>The Medicine and the Muse Program at Stanford University</li> 
        <li>Bay Street Theatre, Southampton Arts Center, and the Joseph J Theinert Foundation in Shelter Island and Sag Harbor, NY</li> 
        <li>Veteran Artist Program in New York City</li> 
        </ul>For more about The Telling Project,
        click{' '}
        <a href="https://thetellingproject.org/" target="_blank" rel="noreferrer">
          here
        </a>
        <br />
      </>
    ),
  },
  {
    name: 'In The Wake (2017)',
    refId: 'itw',
    tags: ['Contemporary', 'Chicago'],
    images: [
      {
        src: '/images/ITW_gallery/1.1proj.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.1proj.jpg',
        title: 'Rose Sengenberger in In The Wake by Lisa Kron',
        alt: 'Rose Sengenberger',
      },
      {
        src: '/images/ITW_gallery/1.1tickle.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.1tickle.jpg',
        title: "Mike Newquist, Erin O'Brien, Adrienne Matzen and Rose Sengenberger in In The Wake by Lisa Kron",
        alt: "Mike Newquist, Erin O'Brien, Adrienne Matzen and Rose Sengenberger",
      },
      {
        src: '/images/ITW_gallery/1.1escape.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.1escape.jpg',
        title: 'Kelli Walker and Rose Sengenberger in In The Wake by Lisa Kron',
        alt: 'Kelli Walker and Rose Sengenberger',
      },
      {
        src: '/images/ITW_gallery/1.2kiss.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.2kiss.jpg',
        title: 'Alison Plott and Rose Sengenberger in In The Wake by Lisa Kron',
        alt: 'Alison Plott and Rose Sengenberger',
      },
      {
        src: '/images/ITW_gallery/1.4kayla.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.4kayla.jpg',
        title: 'Adrienne Matzen and Kelli Walker in In The Wake by Lisa Kron',
        alt: 'Adrienne Matzen and Kelli Walker',
      },
      {
        src: '/images/ITW_gallery/1.4tessa.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/1.4tessa.jpg',
        title: 'Samantha Newcomb and Adrienne Matzen in In The Wake by Lisa Kron',
        alt: 'Samantha Newcomb and Adrienne Matzen',
      },
      {
        src: '/images/ITW_gallery/2.1love.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/2.1love.jpg',
        title: 'Alison Plott and Rose Sengenberger in In The Wake by Lisa Kron',
        alt: 'Alison Plott and Rose Sengenberger',
      },
      {
        src: '/images/ITW_gallery/2.2feet.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/2.2feet.jpg',
        title: "Erin O'Brien and Adrienne Matzen in In The Wake by Lisa Kron",
        alt: "Erin O'Brien and Adrienne Matzen",
      },
      {
        src: '/images/ITW_gallery/2.7nothing.jpg',
        thumbnail: '/images/ITW_gallery/thumbs/2.7nothing.jpg',
        title: 'Rose Sengenberger in In The Wake by Lisa Kron',
        alt: 'Rose Sengenberger',
      },
    ],
    showThumbnail: '/images/ITW_gallery/thumbs/2.1love-xs.jpg',
    headline: (
      <>
        <em>In The Wake</em> with The Comrades at Greenhouse Theater Center
      </>
    ),
    description: (
      <>
        written by Lisa Kron
        <br />
        Lighting Design by Nicholas Coso, Scenic Design by Rachel Rauscher, Projections Design by G. Max Maxin IV,
        Costume Design by Alycia Matz, Sound Design by Becca Venable.
        <br />
        Photos by Paul Goyette.
      </>
    ),
  },
  {
    name: 'I Run With You (2016)',
    refId: 'ak',
    tags: ['Musicals', 'New Plays'],
    images: [
      {
        src: '/images/annakate_gallery/irunwithyou1.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou1.JPG',
        title: 'Set for I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'I Run With You',
      },
      {
        src: '/images/annakate_gallery/irunwithyou4.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou4.JPG',
        title: 'Anna Gothard and Kate Foster in I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'Anna/Kate',
      },
      {
        src: '/images/annakate_gallery/irunwithyou3.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou3.JPG',
        title: 'Anna Gothard and Kate Foster in I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'Anna/Kate',
      },
      {
        src: '/images/annakate_gallery/irunwithyou5.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou5-horiz.JPG',
        title: 'Kate Foster and Anna Gothard in I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'Anna/Kate',
      },
      {
        src: '/images/annakate_gallery/irunwithyou6.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou6.JPG',
        title: 'Kate Foster and Anna Gothard in I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'Anna/Kate',
      },
      {
        src: '/images/annakate_gallery/irunwithyou2.JPG',
        thumbnail: '/images/annakate_gallery/thumbs/irunwithyou2-horiz.JPG',
        title: 'Audience for I Run With You at the Crisis Art Festival in Arezzo, Italy',
        alt: 'Audience for I Run With You',
      },
    ],
    showThumbnail: '/images/annakate_gallery/thumbs/irunwithyou5-xs.JPG',
    headline: (
      <>
        <em>I Run With You</em> at the Crisis Art Festival in Arezzo, Italy
      </>
    ),
    description: (
      <>
        written and performed by Anna/Kate
        <br />
        A theatrical song cycle about queer love, grief, and depression.
        <br />
        Listen to Anna/Kate's album EP{' '}
        <a href="https://annakatemusic.bandcamp.com/album/i-run-with-you-e-p" target="_blank" rel="noreferrer">
          here
        </a>
      </>
    ),
  },
  {
    name: 'Dijla Wal Furat: Between the Tigris and the Euphrates',
    shortName: 'Dijla Wal Furat (2015)',
    refId: 'dwf',
    tags: ['Military Veterans', 'New Plays', 'New York'],
    images: [
      {
        src: '/images/DWF_gallery/Web_Y1A0085.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0085.jpg',
        title: 'Fahim Hamid and Ankur Rathee in Dijla Wal Furat by Maurice Decaul',
        alt: 'Fahim Hamid and Ankur Rathee',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0100.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0100-horiz.jpg',
        title: 'Fahim Hamid and Ankur Rathee in Dijla Wal Furat by Maurice Decaul',
        alt: 'Fahim Hamid and Ankur Rathee',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0112.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0112-horiz.jpg',
        title: 'Perri Yaniv in Dijla Wal Furat by Maurice Decaul',
        alt: 'Perri Yaniv',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0232.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0232.jpg',
        title: 'Nabil Viñas in Dijla Wal Furat by Maurice Decaul',
        alt: 'Nabil Viñas',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0237.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0237.jpg',
        title: 'Katie Zaffrann in Dijla Wal Furat by Maurice Decaul',
        alt: 'Katie Zaffrann',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0368.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0368.jpg',
        title: 'Nabil Viñas and Temesgen Tocruray in Dijla Wal Furat by Maurice Decaul',
        alt: 'Nabil Viñas and Temesgen Tocruray',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0406.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0406.jpg',
        title: 'Ali Andre Ali in Dijla Wal Furat by Maurice Decaul',
        alt: 'Ali Andre Ali',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0446.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0446.jpg',
        title: 'Temesgen Tocruray and Victory Chappotin in Dijla Wal Furat by Maurice Decaul',
        alt: 'Temesgen Tocruray and Victory Chappotin',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0479.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0479-horiz.jpg',
        title: 'Nabil Viñas and Victory Chappotin in Dijla Wal Furat by Maurice Decaul',
        alt: 'Nabil Viñas and Victory Chappotin',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0546.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0546.jpg',
        title: 'Temesgen Tocruray and Perri Yaniv in Dijla Wal Furat by Maurice Decaul',
        alt: 'Temesgen Tocruray and Perri Yaniv',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0573.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0573.jpg',
        title: 'Katie Zaffrann in Dijla Wal Furat by Maurice Decaul',
        alt: 'Katie Zaffrann',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0602.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0602.jpg',
        title: 'Fahim Hamid and Ankur Rathee in Dijla Wal Furat by Maurice Decaul',
        alt: 'Fahim Hamid and Ankur Rathee',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0673.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0673.jpg',
        title: 'Victory Chappotin in Dijla Wal Furat by Maurice Decaul',
        alt: 'Victory Chappotin',
      },
      {
        src: '/images/DWF_gallery/Web_Y1A0026.jpg',
        thumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0026.jpg',
        title: 'Ali Andre Ali in Dijla Wal Furat by Maurice Decaul',
        alt: 'Ali Andre Ali',
      },
    ],
    showThumbnail: '/images/DWF_gallery/thumbs/Web_Y1A0112-xs.jpg',
    headline: (
      <>
        <em>Dijla Wal Furat: Between the Tigris and the Euphrates</em> with Poetic Theater Productions
      </>
    ),
    description: (
      <>
        written by Maurice Decaul
        <br />
        Lighting Design by Derek Miller, Costume Design by Liene Dobraja, Sound Design by Jamie A. Diaz, Properties
        Design by Travis Bell, Set Design by Paul DePoo III, Technical Direction by Ori Bensimhon, Assistant Direction
        by Jessica Barnhill.
        <br />
        Photos by Bjorn Bolinder.
      </>
    ),
  },
  {
    name: 'faith (2012)',
    refId: 'faith',
    tags: ['New Plays', 'Solo Shows', 'New York'],
    images: [
      {
        src: '/images/faith/Faith_015.jpg',
        thumbnail: '/images/faith/thumbs/Faith_015.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_023.jpg',
        thumbnail: '/images/faith/thumbs/Faith_023.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_025.jpg',
        thumbnail: '/images/faith/thumbs/Faith_025.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_085.jpg',
        thumbnail: '/images/faith/thumbs/Faith_085.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_031.jpg',
        thumbnail: '/images/faith/thumbs/Faith_031.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_096.jpg',
        thumbnail: '/images/faith/thumbs/Faith_096.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_098.jpg',
        thumbnail: '/images/faith/thumbs/Faith_098.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_103.jpg',
        thumbnail: '/images/faith/thumbs/Faith_103.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
      {
        src: '/images/faith/Faith_130.jpg',
        thumbnail: '/images/faith/thumbs/Faith_130.jpg',
        title: 'Caroline Rothstein in faith',
        alt: 'Caroline Rothstein in faith',
      },
    ],
    showThumbnail: 'images/faith/thumbs/faith85crop.png',
    headline: (
      <>
        <em>faith</em> at Culture Project's Women Center Stage Festival
      </>
    ),
    description: (
      <>
        written and performed by Caroline Rothstein
        <br />
        A one-woman play about surviving a decade-long eating disorder in poetry and prose. Developed with Poetic
        Theater Productions and remounted at Planet Connections Theatre Festivity and Poetic License in partnership with
        Timberline Knolls. Recipient of the 2012 Planet Connections Theatre Festivity Award for Outstanding Production
        of a Solo Show.
        <br />
      </>
    ),
  },
  {
    name: 'Writopia Worldwide Plays Festival ',
    shortName: 'Writopia (2014-15)',
    refId: 'writopia',
    tags: ['New Plays','Puppets', 'Community Engaged', 'Musicals', 'New York'],
    images: [
      {
        src: '/images/writopia/watercolor.jpg',
        thumbnail: '/images/writopia/thumbs/watercolor.jpg',
        title: 'Painting a Wife in Watercolor',
        alt: 'Painting a Wife in Watercolor',
      },
      {
        src: '/images/writopia/numb2.jpg',
        thumbnail: '/images/writopia/thumbs/numb2.jpg',
        title: 'Maggie Lalley and Edward Chin-Lyn in Numb',
        alt: 'Numb',
      },
      {
        src: '/images/writopia/march1.jpg',
        thumbnail: '/images/writopia/thumbs/march1.jpg',
        title: 'Simoné Elizabeth Bart, Roland Lane and Alesandra Nahodil in March 21st',
        alt: 'March 21st',
      },
      {
        src: '/images/writopia/fitz2.jpg',
        thumbnail: '/images/writopia/thumbs/fitz2.jpg',
        title: 'Mike Wirsch in Tales of the Fitzwilliams',
        alt: 'Tales of the Fitzwilliams',
      },
      {
        src: '/images/writopia/fitz3.jpg',
        thumbnail: '/images/writopia/thumbs/fitz3-horiz.jpg',
        title: 'Jarrod Bates in Tales of the Fitzwilliams',
        alt: 'Tales of the Fitzwilliams',
      },
      {
        src: '/images/writopia/epic1.jpg',
        thumbnail: '/images/writopia/thumbs/epic1.jpg',
        title: 'Samantha Cooper and Temesgen Tocruray in The Epic Of by Rachel Calnek-Sugin',
        alt: 'The Epic Of',
      },
    ],
    headline: <>Writopia Worldwide Plays Festival</>,
    showThumbnail: '/images/writopia/thumbs/fitz1-xs.jpg',
    description: (
      <>
        Click the links for video
        <br />
        <a href="https://www.youtube.com/watch?v=c2VWBbBUV9s" target="_blank" rel="noreferrer">
          <em>Painting a Wife in Watercolor</em> by Lizzie McCord
        </a>
        <br />
        <a href="https://www.youtube.com/watch?v=XBAk-O4KNWQ&t=179s" target="_blank" rel="noreferrer">
          <em>Numb</em> by Eleanor Mammen
        </a>
        <br />
        <a href="https://www.youtube.com/watch?v=pYGemznjBQ8" target="_blank" rel="noreferrer">
          <em>March 21st</em> by Kai Williams
        </a>
        <br />
        <a href="https://www.youtube.com/watch?v=TaVkq_ZEuS0" target="_blank" rel="noreferrer">
          <em>Tales of the Fitzwilliams</em> by Davis, Davis, Romeo and Romeo
        </a>
        <br />
        <a href="https://www.youtube.com/watch?v=K5wlr75TDes" target="_blank" rel="noreferrer">
          <em>The Epic Of</em> by Rachel Calnek-Sugin
        </a>
        <br />
      </>
    ),
  },
  {
    name: 'Goliath (2011-14)',
    refId: 'goliath',
    tags: ['New Plays', 'Touring', 'New York', 'Military Veterans'],
    images: [
      {
        src: '/images/goliath_gallery/1_goliath_076.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/1_goliath_076.jpg',
        title: 'Nabil Viñas and ensemble in Goliath by Takeo Rivera (Photo Hunter Canning)',
        alt: 'Nabil Viñas and ensemble',
      },
      {
        src: '/images/goliath_gallery/1_LGCC1.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/1_LGCC1.jpg',
        title: 'Ensemble in Goliath by Takeo Rivera at La Guardia Community College (Photo Dino Garcia)',
        alt: 'Ensemble',
      },
       {
        src: '/images/goliath_gallery/yellowribbons.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/yellowribbons.jpg',
        title: 'Monique Paige and ensemble in Goliath by Takeo Rivera (Photo Kate Hess)',
        alt: 'Monique Paige and ensemble',
      },
      
      /* {
        src: '/images/goliath_gallery/howmanyother.jpg',
        thumbnail: '/images/goliath_gallery/howmanyother.jpg',
        title: 'Ensemble in Goliath by Takeo Rivera',
        alt: 'Ensemble',
      }, */
      {
        src: '/images/goliath_gallery/vietnam.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/vietnam.jpg',
        title: 'Kenneth Heaton and ensemble in Goliath by Takeo Rivera (Photo Hunter Canning)',
        alt: 'Kenneth Heaton and ensemble',
      },
       {
        src: '/images/goliath_gallery/5_goliath_053.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/5_goliath_053.jpg',
        title: 'Ensemble in Goliath by Takeo Rivera (Photo Hunter Canning)',
        alt: 'Ensemble',
      },
      {
        src: '/images/goliath_gallery/4_LGCC2.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/4_LGCC2.jpg',
        title: 'Edgar Eguia and ensemble in Goliath at La Guardia Community College (Photo Dino Garcia)',
        alt: 'Edgar Eguia and ensemble',
      },
      {
        src: '/images/goliath_gallery/waywayback.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/waywayback.jpg',
        title: 'Nabil Viñas and Edgar Eguia in Goliath by Takeo Rivera (Photo Kate Hess)',
        alt: 'Nabil Viñas and Edgar Eguia',
      },
       {
        src: '/images/goliath_gallery/racistassholes.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/racistassholes.jpg',
        title: 'Ensemble in Goliath by Takeo Rivera (Photo Kate Hess)',
        alt: 'Ensemble',
      },
     
      {
        src: '/images/goliath_gallery/hesmybrother.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/hesmybrother.jpg',
        title: 'Samantha Cooper and ensemble in Goliath by Takeo Rivera (Photo Hunter Canning)',
        alt: 'Samantha Cooper and ensemble',
      },
      
     
      /* {
        src: '/images/goliath_gallery/ANSWER.jpg',
        thumbnail: '/images/goliath_gallery/ANSWER.jpg',
        title: 'Samantha Cooper in Goliath by Takeo Rivera',
        alt: 'Samantha Cooper',
      }, */
      /* {
        src: '/images/goliath_gallery/ladies.jpg',
        thumbnail: '/images/goliath_gallery/ladies.jpg',
        title: 'Dontonio Demarco and Nabil Viñas in Goliath by Takeo Rivera',
        alt: 'Dontonio Demarco and Nabil Viñas',
      },
      {
        src: '/images/goliath_gallery/unclesam.jpg',
        thumbnail: '/images/goliath_gallery/unclesam-horiz.jpg',
        title: 'Nabil Viñas in Goliath by Takeo Rivera',
        alt: 'Nabil Viñas',
      },
      {
        src: '/images/goliath_gallery/marriedhim.jpg',
        thumbnail: '/images/goliath_gallery/marriedhim.jpg',
        title: 'Natalia Duong and Nabil Viñas in Goliath by Takeo Rivera',
        alt: 'Natalia Duong and Nabil Viñas',
      },
      {
        src: '/images/goliath_gallery/likealaddin.jpg',
        thumbnail: '/images/goliath_gallery/likealaddin.jpg',
        title: 'Ensemble in Goliath by Takeo Rivera',
        alt: 'Ensemble',
      }, */
      {
        src: '/images/goliath_gallery/seedad.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/seedad.jpg',
        title: 'Nabil Viñas and ensemble in Goliath by Takeo Rivera (Photo Hunter Canning)',
        alt: 'Nabil Viñas and ensemble',
      },
      /* {
        src: '/images/goliath_gallery/welcomemehome.jpg',
        thumbnail: '/images/goliath_gallery/welcomemehome-horiz.jpg',
        title: 'Nabil Viñas and Monique Paige in Goliath by Takeo Rivera',
        alt: 'Nabil Viñas and Monique Paige',
      }, */
      {
        src: '/images/goliath_gallery/9_DSC1342.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/9_DSC1342.jpg',
        title: 'Nabil Viñas and Dontonio Demarco in Goliath by Takeo Rivera (Photo Kate Hess)',
        alt: 'Nabil Viñas and Dontonio Demarco',
      },
      {
        src: '/images/goliath_gallery/9_DSC1331.jpg',
        thumbnail: '/images/goliath_gallery/thumbs/9_DSC1331.jpg',
        title: 'Nabil Viñas in Goliath by Takeo Rivera (Photo Kate Hess)',
        alt: 'Nabil Viñas',
      },
    ],
    showThumbnail: '/images/goliath_gallery/thumbs/vietnam-xs.jpg',
    headline: (
      <>
        <em>Goliath</em> with Poetic Theater Productions at Wild Project
      </>
    ),
    description: (
      <>
        written by Takeo Rivera
        <br />
        featuring Samantha Cooper, Dontonio Demarco, Natalia Duong, Edgar Eguia, Kenneth Heaton, Monique Paige and Nabil
        Viñas.
        <br />
        Lighting Design by Brad Peterson, Stage Management by Sarah Livant.
        <br />
        Photos by Hunter Canning and Kate Hess.
      </>
    ),
  },
];
